export class UserTaskStatus {
    constructor(
      public user_task_status_id: number,
      public user_id: number,
      public task_id: string,
      public status: number,
      public created: string,
      public modified: string,
    ) {}
  }
